export default "__VITE_ASSET__DMM8OmnX__"